<template>
  <IziGrid height="100%" margin="0px" padding="0px">
    <IziCol
      height="90%"
      margin="0px"
      padding="0px"
      col="12"
      class="register-form"
    >
      <IziGrid class="demo">
        <IziCol xl="4" lg="3" md="2" />
        <IziCol xl="4" lg="6" md="8" col="12">
          <RegisterForm />
        </IziCol>
        <IziCol xl="4" lg="3" md="2" />
      </IziGrid>
    </IziCol>
    <IziCol height="10%" margin="0px" class="footer">
      <Footer />
    </IziCol>
  </IziGrid>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import RegisterForm from "@/components/registerForm/registerForm.vue";
@Options({
  components: {
    RegisterForm
  }
})
export default class Register extends Vue {}
</script>

<style lang="scss" scoped>
.register-form {
  margin: 0px;
  padding: 0px;
  height: 90%;
}

.footer {
  background: #50e194;
}
</style>
